import React from 'react';

import arrowDown from '../../assets/img/arrow/arrow-down-small.svg';
import arrowUp from '../../assets/img/arrow/arrow-up-small.svg';
import arrowNeutral from '../../assets/img/arrow/arrow-neutral-small.svg';

import './Change.scss';

interface IChange {
  value: number | null;
  decimals?: number;
}

export default function Change({ value, decimals }: IChange): JSX.Element {
  let arrow: string;
  let className: string;

  if (value === null) {
    return <span>-</span>;
  }

  if (value === 0) {
    arrow = arrowNeutral;
    className = 'neutral';
  } else if (value > 0) {
    arrow = arrowUp;
    className = 'positive';
  } else {
    arrow = arrowDown;
    className = 'negative';
  }

  return (
    <div className="Change">
      {value != null ? (
        <span className={`Change__${className} fcc`}>
          <span className="Change__value">{value.toFixed(decimals) ?? '-'}</span>{' '}
          <img src={arrow} alt="" />
        </span>
      ) : (
        '-'
      )}
    </div>
  );
}

Change.defaultProps = {
  decimals: 2,
};
